// Persistent stores
import { openDB, DBSchema, IDBPDatabase } from 'idb';
import FileSystemStore from './FileSystemStore';
import MusicStore, { SongEntry } from './MusicStore';

export interface CADBSchema extends DBSchema {
  handles: {
    key: string;
    value: FileSystemHandle;
  };

  songs: {
    key: string;
    value: SongEntry;
    indexes: {
      title: string;
      album: string;
      artist: string;
      path: string[];
    };
  };
}

export type Database = IDBPDatabase<CADBSchema>;

export let fileSystemStore: FileSystemStore;
export let musicStore: MusicStore;

// Need to register all persistent stores here
export const Ready = (async function() {
  const db = await openDB<CADBSchema>('civilian-applications', 1, {
    upgrade(db, oldVersion, newVersion) {
      console.log('Doing upgrade');

      FileSystemStore.Upgrade(db, oldVersion, newVersion);
      MusicStore.Upgrade(db, oldVersion, newVersion);
    }
  });

  console.log('Regular old init');
  fileSystemStore = new FileSystemStore(db);
  musicStore = new MusicStore(db);
})();

// Non-persistent stores
export { default as currentlyPlayingStore } from './CurrentlyPlayingStore';
